export default __webpack_public_path__ + "static/screeny-130-gpz-unica-m-5-6b69c7d238cb5c088d65881ee5cf9059.jpg";